import './eos-overview.scss';

import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { DisplayMessage } from '@core/app/scripts/services/display-message';
import { EndOfShift } from '@pos/app/scripts/services/end-of-shift';
import { Mask } from '@core/app/scripts/services/mask';
import { Persist } from '@core/app/scripts/services/persist';
import { SettingsManager } from '@shared/app/scripts/services/settings-manager';

/*
 * Component responsible for /eos-overview route.
 */
angular
  .module('posApp')
  .directive(
    'eosOverview',
    (
      displayMessage: DisplayMessage,
      endOfShift: EndOfShift,
      eosSubmit,
      mask: Mask,
      navigateTo: NavigateTo,
      persist: Persist,
      pos,
      settingsManager: SettingsManager,
      translate: ng.translate.ITranslateService,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./eos-overview.html').default,

      link: function ($scope, element, attrs) {
        const $translate = translate;

        $scope.paymentMethods = settingsManager.settings.paymentMethods;

        $scope.email = persist.get('eosEmail') ? persist.get('eosEmail') : '';
        $scope.validShift = false;

        $scope.eos = {};

        $scope.eosSubmit = eosSubmit;

        function updateEOSOriginalValues() {
          endOfShift.originalEOSValues = {
            payments: angular.copy(endOfShift.payments),
            totals: angular.copy(endOfShift.totals),
            cashDepositedInPOS: endOfShift.cashDepositedInPOS,
            eos: angular.copy(endOfShift.eos),
          };
        }

        // load data from spynl eos/overview
        function loadEosOverview() {
          $scope.validShift = false;

          displayMessage.showLoading();

          endOfShift.load(pos.selectedDevice.device_id).then(
            () => {
              $scope.eos = endOfShift.eos;
              $scope.totals = endOfShift.totals;

              $scope.validShift = true;
            },
            (response) => {
              $scope.eos = {};
              mask.hide();
              $scope.validShift = false;
              if (angular.isString(response)) {
                displayMessage.message({
                  message: response,
                  type: 'info',
                });
              } else if (response?.data && response.data?.message) {
                displayMessage.message({
                  message: response.data.message,
                  type: 'info',
                });
              } else {
                displayMessage.message($translate.instant('ServerError'));
              }
            },
          );
        }

        endOfShift.initEosOverview(
          pos.selectedDevice,
          pos.config.selectedCashier,
        );

        loadEosOverview();

        $scope.openMailPopup = () => {
          $scope.emailPopupOpened = true;
        };

        $scope.getConsignmentTotal = () => {
          if (
            endOfShift.payments.other.consignment &&
            endOfShift.payments.other.consignment.value
          ) {
            return endOfShift.payments.other.consignment.value;
          } else {
            return 0;
          }
        };

        $scope.getTotal = (type) =>
          endOfShift.totals[type] ? endOfShift.totals[type] : 0;

        $scope.getTotalCashDepositInPOS = () => endOfShift.totals.cash;

        $scope.onDepositChange = () => {
          $scope.eos.endBalance =
            endOfShift.eos.expectedCashInDrawer - endOfShift.eos.deposit;
        };

        $scope.getMaxDeposit = () =>
          endOfShift.maxDep ? endOfShift.maxDep : 0;

        const pay = (type, id) => {
          if (endOfShift.payments[type] && endOfShift.payments[type][id]) {
            return endOfShift.payments[type][id].value;
          }
          return 0;
        };

        $scope.cancel = () => {
          const message = $translate.instant('AreYouSure');

          displayMessage.message({
            message: message,
            type: 'prompt',
            callback: (result) => {
              if (result === 'yes') {
                $scope.$apply(() => {
                  endOfShift.reset();
                  navigateTo('pos.route#more');
                });
              }
            },
          });
        };

        $scope.edit = () => {
          if ($scope.validShift) {
            // Attempt to prevent users from processing the same EOS twice
            if (endOfShift.eos.status === 'completed') {
              displayMessage.message({
                message: $translate.instant(
                  'TheEOSHasAlreadyBeenProcessedForThisPeriod',
                ),
                ok: true,
                type: 'errorprompt',
              });
              return;
            }

            endOfShift.eos.edited = true;
            endOfShift.eos.status = 'editing';

            updateEOSOriginalValues();

            navigateTo('pos.route#eos-edit');
          }
        };

        $scope.openTotals = (paymentKey, label) => {
          $scope.selectedTotal = {
            value: endOfShift.totals[paymentKey],
            // is called with 'Total Cash', 'Total Electronic', 'Total Other'
            label: $translate.instant(label),
          };

          if (paymentKey === 'electronic') {
            $scope.infoPays = [
              {
                value: endOfShift.eos.final.creditcard,
                label: $translate.instant('creditcard'),
              },
              {
                value: endOfShift.eos.final.pin,
                label: $translate.instant('pin'),
              },
            ];
          }

          if (paymentKey === 'other') {
            $scope.infoPays = [
              {
                value: endOfShift.eos.final.couponin,
                label: $translate.instant('couponin'),
              },
              {
                value: endOfShift.eos.final.couponout,
                label: $translate.instant('couponout'),
              },
              {
                value: endOfShift.eos.final.creditreceipt,
                label: $translate.instant('creditreceipt'),
              },
              {
                value: endOfShift.eos.final.creditreceiptin,
                label: $translate.instant('creditreceiptin'),
              },
              {
                value: endOfShift.eos.final.storecredit,
                label: $translate.instant('storecredit'),
              },
              {
                value: endOfShift.eos.final.storecreditin,
                label: $translate.instant('storecreditin'),
              },
            ];
          }

          $scope.totalsOpened = true;
        };
      },
    }),
  );
